<template>
    
    <div v-show="diplay_main_question">
        <ChooseButtonComponent 
            :buttons="mainQuestionButtons"
            v-on:choose-button="changePrincipalQuestion($event)"
            :label="`¿El beneficio de ${product_name} es para usted o para un asegurado adicional?`" 
            :buttons_styles="buttons_styles"
        />

        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of aditionalPeronalInformationModelValidation.is_additional_insured.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div>
    </div>

    <!-- Select relationship -->
    <div v-show="diplay_relationship">
            <ChooseButtonComponent 
            :buttons="relationshipButtons"
            v-on:choose-button="changeRelationship($event)"
            label="Relación con el solicitante:" 
            :buttons_styles="buttons_styles"/>

            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of aditionalPeronalInformationModelValidation.relationship.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div>
    </div>

    <div >
        <DatosPersonalesComponent ref="PersonalDataRef" :view_class_view="view_class_personal_data" :validations="validationsPersonalData" :buttons_styles="buttons_styles" />
        <BirthPlaceComponent ref="BirthPlaceRef" :key_token_storage="'login'" :urlAPI="url_api_birth_place" :view_class_view="view_class_birthplace" :validations="validationsBirthplace" :buttons_styles="buttons_styles" :show_external_countries="false"/>
        <QuotationHeightAndWeightComponent ref="HeightAndWeightRef" :view_class_view="view_class_quotation_height_weight" :validations="validationsQuotationHeightWeight" :buttons_styles="buttons_styles" />
        
        <!-- Select marital status -->
        <div>
            <label for="select_civil_status">Selecciona el estado civil:</label>
            <select id="select_civil_status" class="w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none" v-model="aditionalPersonalInformation.marital_status">
                <option value="" selected disabled></option>
                <option v-for="civilStatus in civilStatusList" :key="civilStatus.value" :value="civilStatus.value" :disabled="(civilStatus.value=='México')? true: false">
                    {{ civilStatus.text }}
                </option>
            </select>
            <div :class="view_class_view.div_container_error.container" v-for="(error,index) of aditionalPeronalInformationModelValidation.marital_status.$errors" :key="index">
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
            </div>
        </div>

    </div>

</template>

<script>
import { ref } from 'vue';
import ChooseButtonComponent  from './../Forms/ChooseButton';

import DatosPersonalesComponent  from './../DatosPersonales';
import BirthPlaceComponent  from './../BirthPlace';
import QuotationHeightAndWeightComponent  from './QuotationHeightAndWeight';
import useVuelidate from '@vuelidate/core';

export default{
    props: {
        product_name: {
            type: String,
            required: true,
            validator: function(value){
                if(value == ""){
                    return false
                }
                return true;
            }
        },
        buttons_styles: {
            type: Object,
            required: false,
            validator: function(value) {
                if( !value.activeColorBackground || !value.inactiveColorBackground || !value.activeColorText || !value.inactiveColorText || !value.activeBorderColor || !value.inactiveBorderColor ){
                    return false;
                }
                return true;
            }
        },
        key_token_storage:{
            type: String,
            required: true
        },
        urlAPI:{
            type: String,
            required: true
        },
        view_class_view:{
            type: Object,
            required: false,
            defautl(){
                return {
                    class_inputs: {
                        valid: "border-blue-600",
                        no_valid: "border-red-600",
                        default: ""
                    },
                    div_container_error: {
                        container: "my-2",
                        text_error: "text-red-600",
                    },
                    div_container: "w-full",
                }
            }
        },
        validations:{
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        validationsPersonalData: {
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        validationsBirthplace: {
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        validationsQuotationHeightWeight: {
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        diplay_relationship: {
            type: Boolean,
            required: true,
            default() {
                return true
            }
        },
        gendersButtons:{
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        mainQuestionButtons:{
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        relationshipButtons:{
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        civilStatusList:{
            type: Object,
            required: true,
            defautl(){
                return {}
            }
        },
        diplay_main_question:{
            type: Boolean,
            required: true,
            defautl(){
                return true
            }
        },
        url_api_birth_place:{
            type: String,
            required: true,
            defautl(){
                return ""
            }
        }
    },
    setup(props) {

        const PersonalDataRef = ref(null);
        const BirthPlaceRef = ref(null);
        const HeightAndWeightRef = ref(null);

        const view_class_personal_data = {
            input_label:"w-full RobotoRegular text-base",
            input_class: {
                valid:"border-blue-600",
                no_valid:"border-red-600",
                default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
            },
            div_container_error:{
                container:"my-2",
                text_error:"text-red-600",
            },
            div_container:"grid grid-cols-1 sm:grid-cols-1 sm:gap-5",
        };

        const view_class_birthplace = {
            input_class:{
                valid:"border-blue-600",
                no_valid:"border-red-600",
                default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
            },
            div_container_error:{
                container:"my-2",
                text_error:"text-red-600",
            },
            div_container:"grid",
            choose_button_nacionality:"flex flex-wrap w-full inline md:w-1/3 mb-6 md:mb-6",
            div_conatiner_states:"w-full md:w-full",
            div_conatiner_municipalities:"w-full md:w-full",
            div_conatiner_cities:"w-full md:w-full"
        }

        const view_class_quotation_height_weight = {
            class_inputs:{
                valid:"border-blue-600",
                no_valid:"border-red-600",
                default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
            },
            div_container_error:{
                container:"my-2",
                text_error:"text-red-600",
            },
            div_container:"grid grid-cols-1 sm:gap-5 mt-5",
        }

        const show_inputs = {
            rfc:true,
            curp:true,
            dateBirth:true,
            paternalName:true,
            maternalName:true,
            name:true,
            secondName:true,
            gender:true
        };

        const aditionalPersonalInformation = ref({
            is_additional_insured: "",
            marital_status: "",
            relationship: ""
        });

        const aditionalPeronalInformationModelValidation = useVuelidate(props.validations, aditionalPersonalInformation.value);

        function changePrincipalQuestion(value){
            aditionalPersonalInformation.value.is_additional_insured = value;
        }

        function changeRelationship(value){
            aditionalPersonalInformation.value.relationship = value;
        }

        function execute_validation(){
            let PersonalDataRefs = PersonalDataRef.value.execute_validation();
            let BirthPlaceRefs = BirthPlaceRef.value.execute_validation();
            let HeightAndWeightRefs = HeightAndWeightRef.value.execute_validation();
            aditionalPeronalInformationModelValidation.value.$validate();
            
            if(aditionalPeronalInformationModelValidation.value.$error || !PersonalDataRefs || !BirthPlaceRefs || !HeightAndWeightRefs){
                return false;
            }
            
            const { curp, dateBirth, firstName, gender, maternalName, paternalName, rfc, secondName } = PersonalDataRefs;
            const { city, country, state, municipality } = BirthPlaceRefs;
            const { height, weight } = HeightAndWeightRefs;

            let personalData = {
                is_additional_insured: aditionalPersonalInformation.value.is_additional_insured,
                relationship: aditionalPersonalInformation.value.relationship,
                marital_status: aditionalPersonalInformation.value.marital_status,
                curp: curp !== undefined?  curp: '',
                date_birth: dateBirth !== undefined? dateBirth : '',
                first_name: firstName !== undefined? firstName : '',
                gender: gender !== undefined? gender : '',
                maternal_name: maternalName !== undefined? maternalName : '',
                paternal_name: paternalName !== undefined? paternalName : '',
                rfc: rfc !== undefined? rfc : '',
                second_name: secondName !== undefined? secondName : '',
                city: city !== undefined? city : '',
                country: country !== undefined? country : '',
                state: state !== undefined? state : '',
                municipality: municipality !== undefined? municipality : '',
                height: height !== undefined? height : '',
                weight: weight !== undefined? weight : '',
            }
            return personalData;
        }

        return {
            changePrincipalQuestion,
            changeRelationship,
            execute_validation,
            view_class_personal_data,
            show_inputs,
            PersonalDataRef,
            BirthPlaceRef,
            HeightAndWeightRef,
            view_class_birthplace,
            aditionalPersonalInformation,
            view_class_quotation_height_weight,
            aditionalPeronalInformationModelValidation
        };
    },
    components: {
        ChooseButtonComponent,
        DatosPersonalesComponent,
        BirthPlaceComponent,
        QuotationHeightAndWeightComponent
    }
}
</script>